import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  beneficersLength: 0,
  beneficers: [],
}

export default function beneficersReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_BENEFICERS:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_BENEFICERS:
      return {...state, saveLoader: action.payload}
    case actions.GET_BENEFICERS:
      return {...state, beneficers: action.payload.beneficers, beneficersLength: action.payload.beneficersLength}
    default:
      return state
  }
}